import React, {useState} from "react"
import {
        Form,
        Button,
        ProgressBar,
        Alert
    } from "react-bootstrap"
import { useSelector } from "react-redux"
import { toast } from "react-toastify"
import FormContainer from "../components/FormContainer"
import Loader from "../components/Loader"

//import { useSendResetPasswordRequestMutation } from "../slices/usersApiSlices"
import {
    useGetUserProfileQuery,
    useUpdateUserPasswordMutation,
} from "../slices/usersApiSlices"



const UpdatePasswordScreen = () => {
    const { userInfo } = useSelector((state) => state.auth)
    //const [emailInput, setEmailInput] = useState("")
    const [oldPassword, setOldPassword] = useState("")
    const [newPassword, setNewPassword] = useState("")
    const [confirmNewPassword,setConfirmNewPassword] = useState("")
    const [errorMessage, setErrorMessage] = useState("")

    const [updatePassword, {isLoading}] = useUpdateUserPasswordMutation()
    const { data: profile, isLoading: profileLoading } = useGetUserProfileQuery(undefined, {
        skip: !userInfo,
        refetchOnMountOrArgChange: true,
    })

    const isGoogleAccount =
        userInfo?.signedInWithGoogle === true ||
        profile?.authProvider === "google"

    // Password strength scoring function
    const getPasswordStrength = (pwd) => {
        let score = 0;
        if (pwd.length >= 8) score += 20;
        if (/[A-Z]/.test(pwd)) score += 20;
        if (/[a-z]/.test(pwd)) score += 20;
        if (/\d/.test(pwd)) score += 20;
        if (/[!@#$%^&*.]/.test(pwd)) score += 20;  // Accepts . without escaping it
        return score;
    };

    // Determine progress bar variant based on score
    const getPasswordVariant = (score) => {
        if (score < 40) return 'danger';
        if (score < 80) return 'warning';
        return 'success';
    };




    const handleSubmit = async (e) => {
        e.preventDefault()

        if (isGoogleAccount) {
            setErrorMessage("Google sign-in accounts cannot update a password.")
            return
        }

        //missing fields
        if ([!oldPassword, !newPassword, !confirmNewPassword].some(i=>i)){
            setErrorMessage("Please fill in all fields")
            return
        }

        //passwords don't match
        if (newPassword !== confirmNewPassword){
            setErrorMessage("Passwords don't match")
            return
        }

        //password security reqs
        const passwordRegex =
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*.])[A-Za-z\d!@#$%^&*.]{8,}$/;
        if (!passwordRegex.test(newPassword)) {
            setErrorMessage('Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character (e.g., !@#$%^&*.).')
            return;
        }

        //{updated, updating, error} = await useUpdateUserPasswordMutation()
        try {
            await updatePassword({oldPassword: oldPassword, newPassword: newPassword}).unwrap()
            toast.success("Password Updated")
        }
        catch (err) {
            toast.error(
                err?.data?.message ||
                err?.error ||
                "Could not update password"
            )
        }
    }

    const strengthScore = getPasswordStrength(newPassword)



    return (
        <FormContainer>
            <title>Update Password | ShotArc</title>
            <h2>Reset Password</h2>
            {isLoading || profileLoading ? <Loader /> : ""}
            <p className="text-danger">{errorMessage || ""}</p>
            {isGoogleAccount ? (
                <Alert variant="warning">
                    This account uses Google sign-in, so there is no ShotArc password to update.
                </Alert>
            ) : (
                <>
            <Form.Group className="mb-4">
                <Form.Label>Enter current password:</Form.Label>
                <Form.Control
                    type="password"
                    placeholder="Old Password"
                    autoComplete="off"
                    name="old-password"
                    required
                    value={oldPassword}
                    onChange={e=>setOldPassword(e.target.value)}
                />
            </Form.Group>

            <Form.Group className="mb-4">
                <Form.Label>Enter new password:</Form.Label>
                <Form.Control
                    type="password"
                    placeholder="New Password"
                    name="new-password"
                    autoComplete="off"
                    required
                    value={newPassword}
                    onChange={e=>setNewPassword(e.target.value)}
                />
                {
                    newPassword && 
                    <ProgressBar 
                        now={strengthScore}
                        variant={getPasswordVariant(strengthScore)}
                        className="mt-2 mb-3"
                    />
                }
            
                <Form.Label>Confirm new password:</Form.Label>
                <Form.Control
                    type="password"
                    placeholder="Confirm New Password"
                    autoComplete="off"
                    required
                    value={confirmNewPassword}
                    onChange={e=>setConfirmNewPassword(e.target.value)}
                />
            </Form.Group>


            <Button
                variant="outline-primary"
                onClick={(e)=>{handleSubmit(e)}}
            >
                Reset Password
            </Button>
                </>
            )}
        </FormContainer>
    )
}

export default UpdatePasswordScreen
